var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPressrelease56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M47.986 13.25a.5.5 0 0 1-.183.683l-3.465 2a.5.5 0 1 1-.5-.866l3.465-2a.5.5 0 0 1 .683.183ZM46 24.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm-1.662 8.567a.5.5 0 0 0-.5.866l3.465 2a.5.5 0 1 0 .5-.866l-3.465-2Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M36.742 8.063A.5.5 0 0 1 37 8.5v32a.5.5 0 0 1-.765.424L20.357 31H12.5c-.333 0-.66-.025-.979-.073l6.821 15.284a2.714 2.714 0 0 0 4.957-2.212v-.001l-3.754-8.291a.5.5 0 1 1 .911-.413l3.756 8.297a3.714 3.714 0 0 1-6.783 3.027l-7.143-16.005A6.502 6.502 0 0 1 12.5 18h7.857l15.878-9.924a.5.5 0 0 1 .507-.013ZM14 19h-1.5a5.5 5.5 0 0 0-1.767 10.71.502.502 0 0 1 .14.045A5.5 5.5 0 0 0 12.5 30H14V19Zm1 11V19h5.5a.5.5 0 0 0 .265-.076L36 9.402v30.196l-15.235-9.522A.5.5 0 0 0 20.5 30H15Z",
  clipRule: "evenodd"
})));
export { SvgPressrelease56 as ReactComponent };
export default __webpack_public_path__ + "5ebd4d46b1964d33452261620bdd1ca3.svg";